﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { error } from "loglevel";
import * as React from "react";
import { SplashPage } from "~base/Pages/Shared/SplashPage";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

type ReloadProps = {};

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

/**
 * Reloads the current page that doesn't exist in the current router (e.g. an admin page)
 * in order for the correct router context to be loaded.
 */
export const ReloadPage: React.FunctionComponent<ReloadProps> = (
    props: ReloadProps
) => {
    const isStuckReloading = window.location.hash == "#redirected";

    setTimeout(() => {
        if (!isStuckReloading) {
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                (!!window.location.search ? "?" + window.location.search : "") +
                "#redirected";
            window.location.reload();
        } else {
            error("Stuck on a ReloadPage!");
        }
    }, 500);

    return <SplashPage isLoading={!isStuckReloading} showSplashScreen />;
};
